/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum CallidusSkipperVersicherungssummeKunde {
    Versicherungssumme5Mio = 'Versicherungssumme5Mio',
    Versicherungssumme10Mio = 'Versicherungssumme10Mio'
  }

    export const CallidusSkipperVersicherungssummeKundeTranslocoMap: Record<CallidusSkipperVersicherungssummeKunde, string> = {
    [CallidusSkipperVersicherungssummeKunde.Versicherungssumme5Mio]: 'callidusSkipperVersicherungssummeKunde.versicherungssumme5Mio',
    [CallidusSkipperVersicherungssummeKunde.Versicherungssumme10Mio]: 'callidusSkipperVersicherungssummeKunde.versicherungssumme10Mio',
    };

    export const CallidusSkipperVersicherungssummeKundeOptions = [
  { value: CallidusSkipperVersicherungssummeKunde.Versicherungssumme5Mio, labelKey: 'callidusSkipperVersicherungssummeKunde.versicherungssumme5Mio' },
  { value: CallidusSkipperVersicherungssummeKunde.Versicherungssumme10Mio, labelKey: 'callidusSkipperVersicherungssummeKunde.versicherungssumme10Mio' },
    ];

